import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { execSeatableSql } from './seatable.js';
import SectionHeader from './sectionheader.js';
import AllImg from './allimg.js';

function ListCapabilities(props) {
    const [heroData, setHeroData] = useState(null);
    const [capabilityData, setCapabilityData] = useState(null);
    // const [error, setError] = useState(null);
    const [rowData, setRowData] = useState(null);

    useEffect(() => {
      async function fetchData() {
        setHeroData(null);
        setCapabilityData(null);
        try {
          const heroRows = await execSeatableSql("SELECT `Subpages`,`Section Title`,`Section Sub Headline`, `fnMediaLink` FROM `Sections` WHERE IsActive IS TRUE AND `PageSection` = 'Hero'");
          setHeroData(heroRows);
          const rows = await execSeatableSql(`SELECT \`_id\`,\`Desc\`,\`ShortDesc\` FROM Subpages WHERE \`CapabilityType\` = '${(props.type === 'Services') ? 'Subpages' : (props.type === 'Segments') ? 'Industry' : ''}' AND \`IsActive\` IS TRUE AND \`IsPublish\` IS TRUE ORDER BY \`Rank Order\``);
          setCapabilityData(rows);
        } catch (err) {
          // setError(err);
        }
      }
      fetchData();
    }, []);

    function mouseOver(e) {
      const id = e.currentTarget.dataset.id;
      setRowData(heroData.results.filter(e => e.Subpages[0].display_value === id));
    }
  
    return (<>
      <div id="Services" className='nav-margin'>
          <SectionHeader capability="Home Page" section={props.type}/>
      </div>
      <div className="section-header d-flex flex-row pb-5 border-bottom border-secondary">
          <div className="flex-grow-1">
            <h1 className="ms-3 mb-4 lato-black">{`${(props.type === 'Services') ? 'Capabilities' : (props.type === 'Segments') ? 'Industries' : ''}`}</h1>
            <ul>
              {capabilityData && capabilityData.results.map((row, index) => {return (
                <Link key={index} data-id={row.Desc} className="my-1 nav-link fs-3" to={`/capabilities/${row.ShortDesc}#top`} onMouseOver={mouseOver}><span>{row.Desc}</span></Link>
              )})}
            </ul>
          </div>
          <div key={rowData && rowData[0]["fnMediaLink"]} className="w-50 list-preview flex-column justify-content-center">
            <div>
              <h3 className="lato-black">{rowData && rowData[0]["Section Title"]}</h3>
              <h3 className="my-5 lato-light">{rowData && rowData[0]["Section Sub Headline"]}</h3>
            </div>
            <div className="col-12">
              <AllImg className="img-fluid" src={rowData && rowData[0]["fnMediaLink"]} alt={rowData && rowData[0]["Section Title"]} />
            </div>
          </div>
      </div>
    </>)
}

export default ListCapabilities;